var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInboxOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFFAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.541 13.6471C27.3528 13.2236 26.941 12.9294 26.4587 12.9294H14.694C14.2116 12.9294 13.7881 13.2236 13.6116 13.6471L11.1646 19.353V25.8706C11.1646 26.5177 11.694 27.0471 12.341 27.0471H28.8116C29.4587 27.0471 29.9881 26.5177 29.9881 25.8706V19.353L27.541 13.6471ZM25.2822 19.9883C24.6351 19.9883 24.1057 20.5177 24.1057 21.1647V22.3412H17.0469V21.1647C17.0469 20.5177 16.5175 19.9883 15.8704 19.9883H13.4587L15.4704 15.2824H25.6822L27.694 19.9883H25.2822Z",
    fill: "#FFB020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxOutline);
export default __webpack_public_path__ + "static/media/inbox_outline.f53cf788f6c8c26873a6c8d3533efee7.svg";
export { ForwardRef as ReactComponent };